import { createApiClient } from 'Network/ApiClient';

export const DrugCodeAxiosInstance = createApiClient('DrugsCode/');


